import { toast } from 'react-toastify';
import { AuthContextProps } from '../../../contexts/authContext';
import BackersService from '../service/BackersService';
import { validateArray } from '../../common/utils/commonUtils';

export default class BackersManager {
  private userId: string;
  private permalink: string;

  constructor(authContext: AuthContextProps) {
    this.userId = authContext?.authState?.id as string;
    this.permalink = authContext?.authState?.permalink as string;
  }

  async getAllBackers() {
    try {
      const response: any = await BackersService.getAllBackers(this.userId);
      let data = response?.data;
      if (validateArray(data?.backers)) {
        data.backers = data?.backers?.map((item: any, index: any) => {
          const newItem = { ...item };
          newItem.backer_id = newItem?.id;
          newItem.id = index;
          return newItem;
        });
      }
      if (validateArray(data?.ca_signed)) {
        data.ca_signed = data?.ca_signed?.map((item: any, index: any) => {
          const newItem = { ...item };
          newItem.backer_id = newItem?.id;
          newItem.id = index;
          return newItem;
        });
      }
      if (validateArray(data?.ca_sent)) {
        data.ca_sent = data?.ca_sent?.map((item: any, index: any) => {
          const newItem = { ...item };
          newItem.backer_id = newItem?.id;
          newItem.id = index;
          return newItem;
        });
      }
      if (validateArray(data?.invited)) {
        data.invited = data?.invited?.map((item: any, index: any) => {
          const newItem = { ...item };
          newItem.backer_id = newItem?.id;
          newItem.id = index;
          return newItem;
        });
      }
      if (validateArray(data?.profile_created)) {
        data.profile_created = data?.profile_created?.map((item: any, index: any) => {
          const newItem = { ...item };
          newItem.backer_id = newItem?.id;
          newItem.id = index;
          return newItem;
        });
      }

      return data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async getBackers(syndicatePermalink: string = '', startupId: string) {
    try {
      let result: any = [];
      syndicatePermalink = syndicatePermalink || localStorage.getItem('syndicate_permalink') || '';
      const response: any = await BackersService.getBackers(syndicatePermalink, startupId);
      if (response?.data?.backers) {
        result = response.data.backers;
      }
      return result;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async getBackerDetail(backerId?: string) {
    try {
      const response: any = await BackersService.getBackerDetail(this.userId, backerId);
      return response?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async inviteMember(data: any) {
    try {
      const formData = { ...data, type_of_investment_profile: data?.type_of_investment_profile?.value };
      const response: any = await BackersService.inviteMemeber(this.userId, 'backer', 'invite', formData);
      return response?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async reInviteMember(
    inv_id: string,
    mode_of_comm: string,
    type_of_comm: string,
    startup_id: string = '',
    investorCommitmentId: string = '',
    resend_drawdown_notice: boolean = false
  ) {
    try {
      const formData = {
        investorCommitmentId,
        resend_drawdown_notice,
        startup_id,
        inv_id,
        mode_of_comm,
        type_of_comm
      };
      const response: any = await BackersService.reInviteMember(this.permalink, formData);
      return response?.data?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async bulkInviteMember(data: any) {
    try {
      const formData = new FormData();
      if (data?.file) formData.append('file', data?.file);
      if (data?.mode_of_comm) formData.append('mode_of_comm', data?.mode_of_comm);

      const response: any = await BackersService.bulkInviteMember(this.userId, formData);
      return response?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async bulkReInviteMember(
    selectedBackers: any,
    mode_of_comm: string,
    type_of_comm: string,
    startup_id: string = '',
    investorCommitmentId: string = '',
    resend_drawdown_notice: boolean = false
  ) {
    try {
      const data = {
        backer_array: selectedBackers,
        startup_id,
        mode_of_comm,
        type_of_comm,
        investorCommitmentId,
        resend_drawdown_notice
      };
      const response: any = await BackersService.bulkReInviteMember(this.permalink, data);
      return response?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async checkCommunicationRecord(inv_id: any, type_of_comm: string) {
    try {
      const response: any = await BackersService.checkCommunicationRecord(this.permalink, inv_id, type_of_comm);
      return response?.data?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }

  async sendTestEmailWhatsapp(data: any, typeOfAction: string, bulk_test_email: boolean = false) {
    try {
      const formData = { ...data, type_of_investment_profile: bulk_test_email ? data?.type_of_investment_profile : data?.type_of_investment_profile?.value };
      const response: any = await BackersService.sendTestEmailWhatsapp(this.userId, typeOfAction, formData);
      return response?.data;
    } catch (error: any) {
      toast.error(error?.message);
      throw error;
    }
  }
}
